const AHome = () => import(/* webpackChunkName:"chunk-policy" */ '@/views/P3_Page/AHome.vue')
const PrivacyPolicy = () => import(/* webpackChunkName:"chunk-policy" */ '@/views/P3_Page/PrivacyPolicy.vue')
const UserProtocol = () => import(/* webpackChunkName:"chunk-policy" */ '@/views/P3_Page/UserProtocol.vue')
const ChildSafetyPolicy = () => import(/* webpackChunkName:"chunk-policy" */ '@/views/P3_Page/ChildSafetyPolicy.vue')

// 历史路由
// prettier-ignore
const historyRoutes = [
  // echo
  {
    path: '/docs/iOS/privacy-protocol', name: 'PrivacyPolicy', component: PrivacyPolicy
  },
  {
    path: '/docs/iOS/user-protocol', name: 'UserProtocol', component: UserProtocol
  },
  // joychat
  {
    path: '/joychat-privacy', name: 'PrivacyPolicy', component: PrivacyPolicy
  },
  {
    path: '/joychat-user', name: 'UserProtocol',  component: UserProtocol
  },
  // kiko
  {
    path: '/docs/kiko/privacy-protocol', name: 'PrivacyPolicy', component: PrivacyPolicy
  },
  {
    path: '/docs/kiko/user-protocol', name: 'UserProtocol', component: UserProtocol
  },
  // vava
  {
    path: '/privacy-agreement',  name: 'PrivacyPolicy', component: PrivacyPolicy
  },
  {
    path: '/user-agreement', name: 'UserProtocol', component: UserProtocol
  },
  // vibeo
  {
    path: '/docs/vibeo/privacy-protocol', name: 'PrivacyPolicy', component: PrivacyPolicy
  },
  {
    path: '/docs/vibeo/user-protocol',  name: 'UserProtocol', component: UserProtocol
  }
]

// 新统一路由
// prettier-ignore
const commonRoutes = [
  {
    path: '/home', name: 'home', component: AHome
  },
  {
    path: '/privacy-policy', name: 'PrivacyPolicy', component: PrivacyPolicy
  },
  {
    path: '/user-protocol', name: 'UserProtocol', component: UserProtocol
  },
  {
    path: '/child-safety-policy', name: 'ChildSafetyPolicy', component: ChildSafetyPolicy
  }
]

const routes = [...historyRoutes, ...commonRoutes]

export default routes
